import index from './index.vue';
import { SelectItem } from './all.type';

export default index;
export {
    SelectItem
};
